export const requestQueue: Array<unknown> = []

/**
 * 判断数据是否为object
 * @param {any} value
 * @return {boolean}
 */
export function isObject(value: any) {
  const type = typeof value
  return value != null && (type === 'object' || type === 'function')
}
